import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useAccessContext } from "../contexts/access_context";
import { CssBaseline } from "@mui/material";
import AlertMessage from "../components/alert_component";
import AuthForm from "../components/signin_component";
import Main from "./main";
import { postRequest } from "../functions/api_functions";

// Tipo de resposta da API
  type LinkResponse = {
    status_code: number;
    school_cnpj: string;
  };

  type StudentsResponse = {
    status_code: number;
    school_cnpj: string;
    student_re: number;
  };

interface ErrorState {
    type: "info" | "error" | "warning" | "success";
    message: string;
  }

const HomePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { setAccess_data, access_data } = useAccessContext();
  const [error, setError] = useState<ErrorState | null>(null);

  // Função de validar link
  const handleCheckLink = async () => {
    setError(null); // Limpa erros anteriores
    // setError({ type: 'info', message: 'Validando link de acesso!' });
    try {
      const response = await postRequest<LinkResponse>("/check_link/", {
        body: { school_link: token },
        headers: {},
      });

      if (response.status_code === 200) {
        // Atualiza o contexto com os dados retornados pela API
        setAccess_data((prevContext) => ({
          ...prevContext,
          school_cnpj: response.school_cnpj,
          students_re: 0,
          access_id: 0,
          profile: 'students'
        }));
      } else {
        // Tratamento de erro específico para status code diferente de 200
        setError({ type: 'info', message: 'Link invalido!' });
      }
    } catch (err: unknown) {
      // Lida com erros específicos ou desconhecidos
      if (err instanceof Error) {
        setError({ type: 'info', message: 'Link Invalido!!' });
      } else {
        setError({ type: 'error', message: 'Erro desconhecido. Tente novamente.' });
      }
    }
  };

  const handleAuthenticate = async (students_re: string) => {
    setError(null); // Limpa erros anteriores
    try {
      const response = await postRequest<StudentsResponse>("/validate_student_access/", {
        body: { students_re: students_re, school_cnpj: access_data.school_cnpj },
        headers: {},
      });

      if (response.status_code === 200) {
        // Atualiza o contexto com os dados retornados pela API
        setAccess_data((prevContext) => ({
          ...prevContext,
          students_re: response.student_re
        }));
      } else {
        // Tratamento de erro específico para status code diferente de 200
        setError({ type: 'info', message: 'Aluno invalido!' });
      }
    } catch (err: unknown) {
      // Lida com erros específicos ou desconhecidos
      if (err instanceof Error) {
        setError({ type: 'info', message: 'Aluno Invalido!!' });
      } else {
        setError({ type: 'error', message: 'Erro desconhecido. Tente novamente.' });
      }
    }
  };

  React.useEffect(() => {
    handleCheckLink()
  }, [])

  return (
    <>
      <CssBaseline />
        {access_data.students_re === 0 ? (
          <>
            {error && 
                (<AlertMessage key={Math.random()} message={error.message} type={error.type} auto_close={false} />)
            }
            {access_data.school_cnpj && access_data.school_cnpj.trim() !== "" ? (
              <AuthForm onAuthenticate={handleAuthenticate} isStudent={true} />
            ) : (
              (<AlertMessage key={Math.random()} message='Validando link...' type='info' auto_close={true} />)
            )}
          </>
        ) : (
          <Main />
        )}
    </>
  );
};

export default HomePage;
